import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        primary: "#0048CB",
        secondary: "#0A1F44",
        accent: "#1E6BFF",
        info: "#2563EB",
        success: "#16A34A",
        warning: "#F59E0B",
        error: "#E11D48",
      },
    },
  },
});
